import { API_MOCKS } from "./mocks";
import { isDevModeEnv } from "../hooks/useIsDevMode";

export const attachMockInterceptor = (instance) => {
  // Mocks are a dev-only convenience — never intercept real requests in prod.
  if (!isDevModeEnv()) {
    return instance;
  }

  instance.interceptors.request.use((config) => {
    const key = `${config.method?.toUpperCase()} ${config.url}`;
    const mock = API_MOCKS[key];
    if (mock) {
      config.adapter = async () => ({
        data: mock,
        status: mock.status ?? 200,
        statusText: mock.statusText ?? "OK",
        headers: mock.headers ?? {},
        config,
        request: {},
      });
    }

    return config;
  });

  return instance;
};